// REACT IMPORTS
import React from "react";

// ICONS IMPORTS
import { CircleTickIcon } from "icons/success/CircleTickIcon";
import { Link, useParams } from "react-router-dom";
import { useTid } from "utils/testid";

/* ------------------------------------- ACCESS REQUEST SUCCESS SCREEN ------------------------------------- */

const AccessRequestSuccess = () => {
  const tid = useTid();
  const { clusterId: cluster_id } = useParams();

  return (
    <div
      className="bg-bgPrimary h-full animate__animated animate__fadeIn "
      data-testid={tid("success-screen")}
    >
      <div className="flex flex-col items-center lg:gap-10 gap-6 max-w-[628px]">
        <span className="lg:block hidden" aria-hidden="true">
          <CircleTickIcon />
        </span>
        <span className="lg:hidden" aria-hidden="true">
          <CircleTickIcon width={60} />
        </span>
        <div className="flex flex-col items-center lg:gap-10 gap-6">
          <div className="text-center text-txtPrimary font-medium lg:text-2xl text-xl leading-normal lg:px-0 px-3">
            Access request submitted successfully
          </div>
          <div className="text-center text-txtParagraph lg:text-xl text-sm lg:leading-[26.04px] bg-bgThird lg:px-10 lg:py-5 py-2 px-[10px] rounded-[6px]">
            We will review your request and notify you via email once approved.
          </div>
          <div className="flex gap-[6px] items-center justify-center w-full">
            <p className="lg:text-base text-sm text-txtParagraph leading-normal">
              Already have an account?
            </p>
            <Link
              to={`/${cluster_id}/login`}
              className="cursor-pointer lg:text-base text-sm text-blue hover:!text-btnPrimaryHover font-medium leading-normal"
              data-testid={tid("login-link")}
              aria-label="Log in instead"
            >
              Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessRequestSuccess;
